/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOrderInvoiceSummaryDtoFromDiscriminatorValue, serializeGetOrderInvoiceSummaryRequest, serializeOrderInvoiceSummaryDto, type ErrorResponse, type GetOrderInvoiceSummaryRequest, type InternalErrorResponse, type OrderInvoiceSummaryDto } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/order-summary/{orderId}
 */
export interface WithOrderItemRequestBuilder extends BaseRequestBuilder<WithOrderItemRequestBuilder> {
    /**
     * Answers how much of an order has been invoiced, per SKU and in total. The ordered quantities are supplied in the body — the order itself is never read — so the breakdown only covers the SKUs you send, and a SKU that was invoiced but not listed is missing from the lines even though its money still counts toward the totals. Voided and cancelled invoices are excluded from every figure. Remaining quantity never goes below zero, so over-invoicing shows as zero remaining rather than a negative. An order with active invoices but no supplied lines reports PartiallyInvoiced, so it is never mistaken for fully invoiced.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrderInvoiceSummaryDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: GetOrderInvoiceSummaryRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OrderInvoiceSummaryDto | undefined>;
    /**
     * Answers how much of an order has been invoiced, per SKU and in total. The ordered quantities are supplied in the body — the order itself is never read — so the breakdown only covers the SKUs you send, and a SKU that was invoiced but not listed is missing from the lines even though its money still counts toward the totals. Voided and cancelled invoices are excluded from every figure. Remaining quantity never goes below zero, so over-invoicing shows as zero remaining rather than a negative. An order with active invoices but no supplied lines reports PartiallyInvoiced, so it is never mistaken for fully invoiced.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: GetOrderInvoiceSummaryRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithOrderItemRequestBuilderUriTemplate = "{+baseurl}/api/invoices/order-summary/{orderId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithOrderItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: WithOrderItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrderInvoiceSummaryDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeGetOrderInvoiceSummaryRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
